var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOnBoarding = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "On_Boarding",
    "data-name": "On Boarding",
    transform: "translate(-15 -338)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 32,
    height: 32,
    rx: 6,
    transform: "translate(15 338)",
    fill: "#e20074"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M16.835,27.774a.708.708,0,0,1,0,.99l-.975.975a.7.7,0,0,1-1.015-.966l1-1A.706.706,0,0,1,16.835,27.774ZM12.49,23.429a.706.706,0,0,0-.99,0L9.612,25.317a.7.7,0,1,0,.99.99l1.888-1.888A.708.708,0,0,0,12.49,23.429Zm2.9,2.9a.706.706,0,0,0-.99,0L13.116,27.6a.7.7,0,0,0,.99.99l1.279-1.279A.7.7,0,0,0,15.386,26.325Zm-1.448-1.448a.706.706,0,0,0-.99,0l-1.584,1.584a.7.7,0,0,0,.99.99l1.584-1.584A.7.7,0,0,0,13.938,24.877Zm7.726-7.05a.321.321,0,0,1-.147.035H18.338L15.5,19.5a1.01,1.01,0,1,0,1.009,1.749l2.426-1.4a.322.322,0,0,1,.327,0l5.578,3.22a1.483,1.483,0,0,1,.143.1l.006,0-3.2-5.389Zm6.327,4.2-3.6-6.069a.463.463,0,0,0-.634-.162l-1.364.81a.463.463,0,0,0-.162.634l3.6,6.069a.463.463,0,0,0,.634.162l1.364-.81A.463.463,0,0,0,27.991,22.025ZM16.614,12.609a1.745,1.745,0,1,0-1.745-1.745A1.745,1.745,0,0,0,16.614,12.609Zm7.929,11.03L19.1,20.5l-2.268,1.309a1.655,1.655,0,0,1-1.656-2.867l.747-.431H11.979a.32.32,0,0,1-.162-.044l-.276-.159L8.208,23.924l1.193.688,1.641-1.641a1.346,1.346,0,0,1,2.294,1.059,1.346,1.346,0,0,1,1.06.389,1.363,1.363,0,0,1,.388,1.059,1.341,1.341,0,0,1,1.447,1.448,1.344,1.344,0,0,1,1.061.389,1.359,1.359,0,0,1,.033,1.872l.745.429a.81.81,0,0,0,.837-1.386l-1.083-.626a.323.323,0,0,1,.324-.559l1.8,1.041a.81.81,0,0,0,.837-1.387q-1.538-.886-3.074-1.775a.323.323,0,1,1,.324-.559l3.794,2.191a.81.81,0,0,0,.81-1.4l-3.981-2.3a.322.322,0,1,1,.321-.559l4.73,2.731a.81.81,0,0,0,.833-1.39Zm-5.007-9.822a1.562,1.562,0,0,0-.871-1.093l-.356-.172a2.391,2.391,0,0,1-3.388,0l-.356.172a1.562,1.562,0,0,0-.871,1.093l-.506,2.219h6.856Zm-8.452,3.088L9.719,16.1a.463.463,0,0,0-.634.162L5.236,22.744a.463.463,0,0,0,.162.634l1.364.81a.463.463,0,0,0,.634-.162l3.849-6.486A.463.463,0,0,0,11.083,16.905Z",
    transform: "translate(14 334.817)",
    fill: "#fff"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOnBoarding);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/on_boarding.b3be8585f9c12b5f9238b37c73adc090.svg";